import type { JSX } from 'react'
type LabelGroupProps = {
  children: JSX.Element[]
}

export default function LabelGroup({ children }: LabelGroupProps): JSX.Element {
  return <div style={{ display: 'flex', flexWrap: 'wrap', margin: '5px 0 10px -5px' }}>{children}</div>
}
